import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Channel } from 'lib-shared-types-channels';

export type PresenceUpdate = {
  is_online?: boolean;
  is_working?: boolean;
  simultaneous_ring?: boolean;
  working_media_types?: string[];
  workloads_by_channel?: Partial<Record<Channel, number>>;
  has_acw?: boolean;
  custom_away_status?: {
    custom_away_status_id: string;
    status_updated_at: string;
  };
  display_name?: string;
  given_name?: string;
  family_name?: string;
  email?: string;
  phone_number?: string;
  avatar_url?: string;
  additional_emails?: string[];
  additional_phone_numbers?: string[];
};

type PresenceOverlayState = {
  members: Record<string, PresenceUpdate>;
};

const initialState: PresenceOverlayState = {
  members: {},
};

export const presenceOverlaySlice = createSlice({
  name: 'presenceOverlay',
  initialState,
  reducers: {
    updateMemberPresence: (
      state,
      action: PayloadAction<{ memberId: string; updates: PresenceUpdate }>,
    ) => {
      const { memberId, updates } = action.payload;
      state.members[memberId] = {
        ...state.members[memberId],
        ...updates,
      };
    },
  },
});

export const { updateMemberPresence } = presenceOverlaySlice.actions;

export const presenceOverlayReducer = presenceOverlaySlice.reducer;
